export default __webpack_public_path__ + "static/media/TheFisrtDigiBank_Logo (1).836a0976.png";